module.exports = __webpack_public_path__ + "static/img/logo_nav.17bb0a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_nav.png
// module id = B+lS
// module chunks = 8